export default function generateRandomString(length: number): string {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  const usedCharacters = new Set<string>();

  while (result.length < length) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      const randomChar = characters[randomIndex];

      if (!usedCharacters.has(randomChar)) {
          result += randomChar;
          usedCharacters.add(randomChar);
      }
  }

  return result;
}